// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.exam-container {
  max-width: 600px;
  margin: 0 auto;
  padding: 2rem;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

.exam-header {
  text-align: center;
  margin-bottom: 2rem;
}

.exam-header h1 {
  font-size: 2.5rem;
  font-weight: 300;
  color: #2c3e50;
  letter-spacing: -0.05em;
}

.exam-list {
  display: grid;
  gap: 1rem;
}

.exam-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 10px;
  padding: 1.25rem 1.5rem;
  transition: all 0.3s ease;
  cursor: pointer;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
}

.exam-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);
  border-color: #4a90e2;
}

.exam-title {
  font-size: 1.1rem;
  color: #2c3e50;
  font-weight: 500;
  transition: color 0.3s ease;
}

.exam-card:hover .exam-title {
  color: #4a90e2;
}

.exam-icon {
  font-size: 1.5rem;
  color: #a0a0a0;
  transition: color 0.3s ease;
}

.exam-card:hover .exam-icon {
  color: #4a90e2;
}

.exam-loader,
.exam-error,
.exam-empty {
  text-align: center;
  padding: 2rem;
  color: #6c757d;
  font-size: 1.2rem;
}

@media (max-width: 768px) {
  .exam-container {
    padding: 1rem;
  }

  .exam-header h1 {
    font-size: 2rem;
  }

  .exam-card {
    padding: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Exams/Examlist.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,iJAAiJ;AACnJ;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".exam-container {\r\n  max-width: 600px;\r\n  margin: 0 auto;\r\n  padding: 2rem;\r\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\r\n}\r\n\r\n.exam-header {\r\n  text-align: center;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.exam-header h1 {\r\n  font-size: 2.5rem;\r\n  font-weight: 300;\r\n  color: #2c3e50;\r\n  letter-spacing: -0.05em;\r\n}\r\n\r\n.exam-list {\r\n  display: grid;\r\n  gap: 1rem;\r\n}\r\n\r\n.exam-card {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  background-color: #ffffff;\r\n  border: 1px solid #e9ecef;\r\n  border-radius: 10px;\r\n  padding: 1.25rem 1.5rem;\r\n  transition: all 0.3s ease;\r\n  cursor: pointer;\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.exam-card:hover {\r\n  transform: translateY(-5px);\r\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);\r\n  border-color: #4a90e2;\r\n}\r\n\r\n.exam-title {\r\n  font-size: 1.1rem;\r\n  color: #2c3e50;\r\n  font-weight: 500;\r\n  transition: color 0.3s ease;\r\n}\r\n\r\n.exam-card:hover .exam-title {\r\n  color: #4a90e2;\r\n}\r\n\r\n.exam-icon {\r\n  font-size: 1.5rem;\r\n  color: #a0a0a0;\r\n  transition: color 0.3s ease;\r\n}\r\n\r\n.exam-card:hover .exam-icon {\r\n  color: #4a90e2;\r\n}\r\n\r\n.exam-loader,\r\n.exam-error,\r\n.exam-empty {\r\n  text-align: center;\r\n  padding: 2rem;\r\n  color: #6c757d;\r\n  font-size: 1.2rem;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .exam-container {\r\n    padding: 1rem;\r\n  }\r\n\r\n  .exam-header h1 {\r\n    font-size: 2rem;\r\n  }\r\n\r\n  .exam-card {\r\n    padding: 1rem;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
